import pkg from '../package.json';
import Voonto from './voonto';

export const VERSION     = pkg.version;
export const $           = window.jQuery || window.$;
export const _           = window._;
export const is          = window.is;
export const R           = window.React;
export const RDOM        = window.ReactDOM;
export const RSVP        = window.RSVP;
export const Cookies     = window.Cookies;
export const moment      = window.moment;
export const LazyLoad    = window.LazyLoad;
export const ready       = Voonto.ready;
export const getInstance = Voonto.getInstance;

ready.then((app) => app.promised('voonto:ready'));



// WEBPACK FOOTER //
// ./src/index.js